var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nftmorefromcollectionlist"},[_c('nft-list',_vm._b({attrs:{"tokens":_vm.items,"per-page":_vm.perPage,"root-margin":"400px 0px"}},'nft-list',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }